/* eslint-disable react/jsx-no-bind */
import { Settings, Search, Refresh } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel';
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Menu,
  CardContent,
  Card,
  TablePagination,
  Modal,
  RadioGroup,
  FormControlLabel,
  useTheme,
  Radio,
  FormHelperText,
  FormControl,
  Divider,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { tokens } from '../../theme';
import logger from '../../utils/logger';

// const initialData = [
//   {
//     id: 1,
//     title: "Banner 1",
//     type: "Image",
//     image: banner3,
//     content: "No content",
//   },
//   {
//     id: 2,
//     title: "Banner 2",
//     type: "Content",
//     image: banner1,
//     content: "Content for Banner 2",
//   },
//   {
//     id: 3,
//     title: "Banner 3",
//     type: "Image",
//     image: banner2,
//     content: "No content",
//   },
// ];

const Banner = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [data, setData] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedBanner, setSelectedBanner] = useState(null);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState('');
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [image, setImage] = useState(null);
  const [errors, setErrors] = useState({
    title: '',
    image: '',
    content: '',
    option: '',
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [originalData, setOriginalData] = useState([]);

  const fetchBanners = async () => {
    try {
      const response = await fetch('http://localhost:3031/banners');
      const result = await response.json();
      setData(result);
      setOriginalData(result);
    } catch (error) {
      logger.error('Error fetching banners:', error);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const handleOpen = () => {
    handleModalOpen(false);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);

    setTitle('');
    setSelectedOption('');
    setImage(null);
    setContent('');
    setErrors({ title: '', image: '', content: '', option: '' });
    setSelectedBanner(null);
  };
  const navigate = useNavigate();

  const handleFileRemove = () => {
    setImage(null);
    setErrors({ ...errors, image: 'No file selected.' });
  };

  const handleModalOpen = (editMode = false) => {
    setIsEditMode(editMode);
    if (editMode && selectedBanner) {
      setTitle(selectedBanner.title);
      setSelectedOption(selectedBanner.type === 'Image' ? 'image' : 'content');
      setImage(selectedBanner.image); // Set the existing image
      setContent(selectedBanner.content);
    } else {
      setTitle('');
      setSelectedOption('');
      setImage(null);
      setContent('');
    }
    setOpen(true);
  };

  const validateInputs = () => {
    let valid = true;
    const newErrors = { title: '', image: '', content: '' };

    if (!title.trim()) {
      newErrors.title = 'Title is required.';
      valid = false;
    } else if (title.trim().length < 3) {
      newErrors.title = 'Title must be at least 3 characters.';
      valid = false;
    }

    if (!selectedOption) {
      newErrors.option = 'Please select the option';
      valid = false;
    }

    if (selectedOption === 'image') {
      if (!image) {
        newErrors.image = 'Image is required.';
        valid = false;
      }
    }

    if (selectedOption === 'content') {
      if (!image) {
        newErrors.image = 'Image is required.';
        valid = false;
      }
      if (!content.trim()) {
        newErrors.content = 'Content is required.';
        valid = false;
      } else if (content.trim().length < 10) {
        newErrors.content = 'Content must be at least 10 characters.';
        valid = false;
      }
    }

    setErrors(newErrors);
    return valid;
  };

  const handleAddBanner = async () => {
    if (validateInputs()) {
      try {
        const bannerData = {
          title,
          type: selectedOption === 'image' ? 'Image' : 'Content',
          content: selectedOption === 'content' ? content : '',
          image:
            'https://blog.olacabs.com/wp-content/uploads/2016/12/OlaSanta-Mailer.jpg' ||
            '', // hard coded the image as of now
        };

        const response = await fetch('http://localhost:3031/banners', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(bannerData),
        });

        if (response.ok) {
          fetchBanners();
          handleClose();
          resetForm();
        } else {
          logger.error('Failed to add banner', await response.text());
        }
      } catch (error) {
        logger.error('Error adding banner:', error);
      }
    }
  };

  const handleEditBanner = async () => {
    if (validateInputs() && selectedBanner) {
      try {
        const formData = new FormData();
        formData.append('title', title);
        formData.append(
          'type',
          selectedOption === 'image' ? 'Image' : 'Content',
        );
        formData.append('content', selectedOption === 'content' ? content : '');
        if (image)
          formData.append(
            'image',
            'https://blog.olacabs.com/wp-content/uploads/2016/12/OlaSanta-Mailer.jpg',
          ); // hard coded the image as of now

        const response = await fetch(
          `http://localhost:3031/banners/${selectedBanner.id}`,
          {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
          },
        );

        if (response.ok) {
          fetchBanners();
          handleClose();
          resetForm();
        } else {
          logger.error('Failed to update banner', await response.text());
        }
      } catch (error) {
        logger.error('Error editing banner:', error);
      }
    }
  };

  const resetForm = () => {
    setTitle('');
    setSelectedOption('');
    setImage(null);
    setContent('');
    setSelectedBanner(null);
    setErrors({ title: '', image: '', content: '' });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      setErrors({ ...errors, image: '' });
    }
  };

  const handleViewDetails = (banner, Id) => {
    navigate(`/banners/${Id}`, { state: { banner } });
  };

  const handleSearch = () => {
    const filteredData = originalData.filter((item) =>
      item.title.toLowerCase().includes(search.toLowerCase()),
    );
    setData(filteredData);
  };

  const handleReset = () => {
    setSearch('');
    setData(originalData);
  };

  const handleMenuOpen = (event, row) => {
    setMenuAnchor(event.currentTarget);
    setSelectedBanner(row);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDelete = async () => {
    try {
      const response = await fetch(
        `http://localhost:3031/banners/${selectedBanner.id}`,
        {
          method: 'DELETE',
        },
      );
      if (response.ok) {
        fetchBanners();
        handleMenuClose();
      }
    } catch (error) {
      logger.error('Error deleting banners:', error);
    }
  };
  return (
    <>
      <Card
        sx={{
          boxShadow: 2,
          borderRadius: 2,
          padding: 1,
          margin: 2,
          marginLeft: 4,
        }}
      >
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingLeft: 4,
              paddingTop: 2,
              paddingBottom: 0,
            }}
          >
            <h3>Banners</h3>
          </Box>
          <Divider />
          <Box sx={{ padding: 4 }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 3,
                gap: 2,
              }}
            >
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                <TextField
                  label="Search"
                  variant="outlined"
                  size="small"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  onKeyPress={(e) => {
                    if (e.key === 'Enter') {
                      handleSearch();
                    }
                  }}
                  sx={{
                    minWidth: 200,
                    '& .MuiOutlinedInput-root': {
                      height: '36px',
                      borderRadius: '8px',
                      backgroundColor: 'white',
                      '&.Mui-focused fieldset': {
                        borderColor: colors.swiftcarry[100],
                        borderWidth: '2px',
                      },
                      '&:hover fieldset': {
                        borderColor: colors.swiftcarry[100],
                      },
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '13px',
                      color: 'gray',
                      '&.Mui-focused': {
                        color: colors.swiftcarry[100],
                      },
                    },
                  }}
                />
                <IconButton
                  onClick={handleSearch}
                  sx={{
                    bgcolor: colors.swiftcarry[100],
                    color: 'white',
                    width: '50px',
                    height: '50px',
                    borderRadius: '12px',
                    boxShadow: '0 2px 8px rgba(0, 201, 150, 0.3)',
                    '&:hover': {
                      bgcolor: colors.swiftcarry[100],
                      transform: 'translateY(-1px)',
                      boxShadow: '0 4px 12px rgba(0, 201, 150, 0.4)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                >
                  <Search fontSize="medium" />
                </IconButton>
                <IconButton
                  onClick={handleReset}
                  sx={{
                    border: `2px solid ${colors.swiftcarry[100]}`,
                    color: colors.swiftcarry[100],
                    backgroundColor: 'white',
                    width: '50px',
                    height: '50px',
                    borderRadius: '12px',
                    '&:hover': {
                      borderColor: colors.swiftcarry[100],
                      backgroundColor: `${colors.swiftcarry[100]}10`,
                      transform: 'translateY(-1px)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                >
                  <Refresh fontSize="medium" />
                </IconButton>
              </Box>
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleOpen}
                  sx={{
                    bgcolor: colors.swiftcarry[100],
                    '&:hover': {
                      bgcolor: colors.swiftcarry[100],
                    },
                  }}
                >
                  Add
                </Button>
              </Box>
            </Box>

            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{ fontWeight: 'bold' }}>Title</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Type</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>Image</TableCell>
                    <TableCell style={{ fontWeight: 'bold' }}>
                      Content
                    </TableCell>

                    <TableCell style={{ fontWeight: 'bold' }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow key={row.id}>
                        <TableCell>{row.title}</TableCell>
                        <TableCell>{row.type}</TableCell>
                        <TableCell>
                          {row.image && (
                            <img
                              src={
                                typeof row.image === 'string'
                                  ? row.image
                                  : URL.createObjectURL(row.image)
                              }
                              alt={row.title}
                              style={{
                                maxWidth: '100px',
                                maxHeight: '50px',
                                borderRadius: '4px',
                              }}
                            />
                          )}
                          {}
                        </TableCell>
                        <TableCell>{row.content}</TableCell>
                        <TableCell>
                          <IconButton
                            onClick={(event) => handleMenuOpen(event, row)}
                          >
                            <Settings />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[5, 10, 50, 100]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                display: 'flex',
                alignItems: 'flex-end',
                '& .MuiToolbar-root': {
                  display: 'flex',
                  width: '500px',
                  flexWrap: 'wrap',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                },
                '& .MuiTablePagination-selectLabel': {
                  marginBottom: '0px',
                },
                '& .MuiTablePagination-displayedRows': {
                  marginBottom: '0px',
                },
                '& .MuiTablePagination-actions': {
                  display: 'flex',
                  alignItems: 'center',
                  gap: '2px',
                },
                '& .MuiTablePagination-input': {
                  minWidth: '30px',
                },
              }}
            />

            <Menu
              anchorEl={menuAnchor}
              open={Boolean(menuAnchor)}
              onClose={handleMenuClose}
            >
              <MenuItem
                onClick={() => {
                  handleViewDetails(selectedBanner, selectedBanner.id);
                  handleMenuClose();
                }}
              >
                View
              </MenuItem>
              <MenuItem
                onClick={() => {
                  handleModalOpen(true);
                  handleMenuClose();
                }}
              >
                Edit
              </MenuItem>
              <MenuItem onClick={handleDelete}>Delete</MenuItem>
            </Menu>
          </Box>
        </CardContent>
      </Card>

      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <h2> {isEditMode ? 'Edit Banner' : 'Add Banner'}</h2>
          <TextField
            fullWidth
            label="Title"
            variant="outlined"
            value={title}
            sx={{
              '& .MuiOutlinedInput-root': {
                '&.Mui-focused fieldset': {
                  borderColor: colors.swiftcarry[100],
                  color: colors.swiftcarry[100],
                },
              },
              '& .MuiInputLabel-root': {
                color: 'gray',
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: colors.swiftcarry[100],
              },
            }}
            onChange={(e) => {
              setTitle(e.target.value);
              setErrors({ ...errors, title: '' });
            }}
            error={!!errors.title}
            helperText={errors.title}
            margin="normal"
          />

          <FormControl error={!!errors.option}>
            <RadioGroup
              value={selectedOption}
              onChange={(e) => {
                setSelectedOption(e.target.value);
                setErrors({ ...errors, option: '' });
              }}
            >
              <Box sx={{ display: 'flex' }}>
                <FormControlLabel
                  value="image"
                  control={
                    <Radio
                      sx={{
                        color: '',
                        '&.Mui-checked': {
                          color: 'primary.main',
                        },
                      }}
                    />
                  }
                  label="Image"
                />
                <FormControlLabel
                  value="content"
                  control={
                    <Radio
                      sx={{
                        color: '',
                        '&.Mui-checked': {
                          color: 'primary.main',
                        },
                      }}
                    />
                  }
                  label="Content"
                />
              </Box>
              {errors.option && (
                <FormHelperText sx={{ marginTop: 0 }}>
                  {errors.option}
                </FormHelperText>
              )}
            </RadioGroup>
          </FormControl>
          {selectedOption === 'image' && (
            <Box display="flex" flexDirection="column" gap={2}>
              {image && (
                <div>
                  <Box display="flex" alignItems="center" gap={1}>
                    <IconButton
                      color="error"
                      onClick={handleFileRemove}
                      disableRipple
                      disableFocusRipple
                      sx={{
                        '&:hover': {
                          bgcolor: 'transparent',
                        },
                      }}
                    >
                      <CancelIcon />
                    </IconButton>
                  </Box>
                  <img
                    src={
                      typeof image === 'string'
                        ? image
                        : URL.createObjectURL(image)
                    }
                    alt="Preview"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '200px',
                      marginBottom: '16px',
                      borderRadius: '4px',
                    }}
                  />
                </div>
              )}
              <Button
                variant="contained"
                component="label"
                color="primary"
                sx={{
                  bgcolor: colors.swiftcarry[100],
                  '&:hover': {
                    bgcolor: colors.swiftcarry[100],
                  },
                  mb: 1,
                }}
              >
                Upload Banner
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleFileChange}
                />
              </Button>
              {errors.image && (
                <FormHelperText sx={{ mt: 0, pt: 0 }} error>
                  {errors.image}
                </FormHelperText>
              )}
            </Box>
          )}
          {selectedOption === 'content' && (
            <Box display="flex" flexDirection="column" gap={2}>
              {image && (
                <div>
                  <img
                    src={
                      typeof image === 'string'
                        ? image
                        : URL.createObjectURL(image)
                    }
                    alt="Preview"
                    style={{
                      maxWidth: '100%',
                      maxHeight: '200px',
                      marginBottom: '16px',
                      borderRadius: '4px',
                    }}
                  />
                  <Box
                    display="flex"
                    maxWidth={'100%'}
                    alignItems="center"
                    gap={1}
                  >
                    <Button
                      color="error"
                      onClick={handleFileRemove}
                      disableRipple
                      disableFocusRipple
                      sx={{
                        '&:hover': {
                          bgcolor: 'transparent',
                        },
                      }}
                    >
                      <Button
                        variant="contained"
                        sx={{ width: '100%' }}
                        color="error"
                      >
                        <CancelIcon />
                        Remove
                      </Button>
                    </Button>
                  </Box>
                </div>
              )}
              <Button
                variant="contained"
                component="label"
                color="primary"
                sx={{
                  bgcolor: colors.swiftcarry[100],
                  '&:hover': {
                    bgcolor: colors.swiftcarry[100],
                  },
                }}
              >
                Upload Banner
                <input
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handleFileChange}
                />
              </Button>
              {errors.image && (
                <FormHelperText error>{errors.image}</FormHelperText>
              )}

              <TextField
                multiline
                rows={4}
                fullWidth
                variant="outlined"
                label="Content"
                value={content}
                onChange={(e) => {
                  setContent(e.target.value);
                  setErrors({ ...errors, content: '' });
                }}
                error={!!errors.content}
                helperText={errors.content}
                placeholder="Enter content here..."
                sx={{
                  '& .MuiOutlinedInput-root': {
                    '&.Mui-focused fieldset': {
                      borderColor: colors.swiftcarry[100],
                      color: colors.swiftcarry[100],
                    },
                  },
                  '& .MuiInputLabel-root': {
                    color: 'gray',
                  },
                  '& .MuiInputLabel-root.Mui-focused': {
                    color: colors.swiftcarry[100],
                  },
                  mb: 2,
                }}
              />
            </Box>
          )}

          <Box sx={{ display: 'flex' }}>
            <Button
              variant="contained"
              onClick={isEditMode ? handleEditBanner : handleAddBanner}
              style={{ marginRight: '8px' }}
              sx={{
                bgcolor: colors.swiftcarry[100],
                '&:hover': {
                  bgcolor: colors.swiftcarry[100],
                },
              }}
            >
              {isEditMode ? 'Edit' : 'Submit'}
            </Button>
            <Button
              variant="outlined"
              onClick={handleClose}
              sx={{
                borderColor: colors.swiftcarry[100],
                color: colors.swiftcarry[100],
                '&:hover': {
                  borderColor: colors.swiftcarry[100],
                },
              }}
            >
              Cancel
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default Banner;
